import { type Query, type QueryClient } from "@tanstack/react-query";

// useGetParsedQuery uses [url, queryParams] as the query key, so match every cached
// spending-controls read (one per week) by its URL.
function isSpendingControlsQuery(query: Query): boolean {
  const [url] = query.queryKey;
  return typeof url === "string" && url.includes("/spending-controls");
}

/** Marks all cached spending-controls reads stale so active weeks refetch in place. */
export function invalidateSpendingControlsQueries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ predicate: isSpendingControlsQuery });
}

/**
 * Reconciles the spending-controls cache after a create/delete mutation. An "apply to all upcoming
 * weeks" write changes an unbounded set of future weeks at once, so any cached week now holds a
 * stale value; dropping them forces a clean refetch on the next visit rather than briefly rendering
 * the stale value before the background refetch lands. A single-week write only needs the viewed
 * week invalidated, which refreshes it in place.
 */
export function reconcileSpendingControlsCache(
  queryClient: QueryClient,
  mutation: { applyToAllUpcoming: boolean }
): void {
  if (mutation.applyToAllUpcoming) {
    queryClient.removeQueries({ predicate: isSpendingControlsQuery });
  } else {
    invalidateSpendingControlsQueries(queryClient);
  }
}
